import $ from 'jquery';
import Swal from 'sweetalert2';
import { setAttachmentAsProfilePhoto } from '~src/api';

export const handleSetPhotoProfile = async (event) => {
  event.preventDefault();
  event.stopPropagation();
  const editorAttachmentId = $(event.currentTarget).data(
    'attachment-profile-item-id'
  );

  const defuntoId = $(event.currentTarget).data('attachment-defunto-id');

  Swal.fire({
    title: 'Sei sicuro?',
    text: 'Vuoi impostare la foto come foto profilo del servizio?',
    type: 'info',
    showCancelButton: true,
    confirmButtonColor: '#278e8e',
    cancelButtonColor: '#d33',
    cancelButtonText: 'No',
    confirmButtonText: 'Si',
  }).then((result) => {
    if (result.value) {
      Swal.fire({
        text: 'Sto impostando la foto come foto profilo...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      setAttachmentAsProfilePhoto(editorAttachmentId, defuntoId).then(() => {
        Swal.hideLoading();
        Swal.fire({
          title: 'Completato!',
          html: 'La foto &egrave; stata impostata come foto profilo.',
          icon: 'success',
          confirmButtonColor: '#278e8e',
        });
      });
    }
  });
};
